export const Checkmark = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="Checkmark">
    <path id="Vector 332" d="M4.65185 14.2386L13.0055 22.5855L27.3059 8.28564" stroke="currentColor" stroke-width="2"/>
  </g>
</svg>`;
